import { fetchJson } from '../base'
import { withoutAdminSchoolId } from '@/utils/systemRequestScope'

const menuBaseUrl = '/drs-serv/menu'

export function getMenuTree(params) {
  return fetchJson(`${menuBaseUrl}/tree`, withoutAdminSchoolId(params))
}

export function getAuthUserMenuTree() {
  return fetchJson(`${menuBaseUrl}/queryTreeByAuthUser`, {})
}

export function getRoleMenuTree(data) {
  return fetchJson(`${menuBaseUrl}/queryTreeByRoleId`, withoutAdminSchoolId(data))
}

export function addMenu(data) {
  return fetchJson(`${menuBaseUrl}/add`, withoutAdminSchoolId(data))
}

export function updateMenu(data) {
  return fetchJson(`${menuBaseUrl}/update`, withoutAdminSchoolId(data))
}

export function deleteMenu(menuId) {
  return fetchJson(`${menuBaseUrl}/delete`, { menuId })
}

export function getMenuDetail(menuId) {
  return fetchJson(`${menuBaseUrl}/detail`, { menuId })
}



// WEBPACK FOOTER //
// ./src/api/system/menu.api.js